"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative min-h-screen flex items-center justify-center px-6 py-20 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-10 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520072/img/constellation_texture_cta.png)] bg-cover bg-center pointer-events-none" />

      {}
      <div ref={ref} className={`
          relative z-10 max-w-3xl w-full
          bg-background/80 backdrop-blur-md border border-muted
          rounded-lg shadow-soft
          px-8 py-12 md:px-12 md:py-16
          text-center
          transition-all duration-[350ms] ease-out-back
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
        `}>
        {}
        <h2 className="text-[2rem] leading-[1.3] font-semibold text-foreground mb-4">
          Engagez une conversation stratégique
        </h2>
        <p className="text-[1.125rem] leading-[1.6] text-muted-foreground mb-10">
          Prenons ensemble le temps d'explorer vos enjeux et d'identifier les leviers de création de valeur pour votre organisation.
        </p>

        {}
        <Link to="/contact">
          <Button size="lg" className="
              inline-flex items-center justify-center
              bg-primary text-foreground-primary
              px-8 py-4 font-semibold text-base
              rounded-md shadow-soft
              hover:scale-[1.03] hover:shadow-medium hover:ring-2 hover:ring-ring/50
              active:scale-100 active:shadow-soft
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
              transition-all duration-[150ms] ease-out-back
            ">Parlons Stratégie</Button>
        </Link>
      </div>
    </section>;
}